// Store has a single GIMMATEK brand; the favicon is set statically in public/index.html
export const appTitle = 'GIMMATEK 店家後台'
